<script setup>
import { ref, onMounted } from 'vue'
import { retrieve_children, filterChildren, delete_child } from '@/services/child';
import { get_terms } from '@/services/term';
import { get_packages } from '@/services/packages';
import { getAge, swalError } from '@/helper';

const children = ref([])
const pagination = ref({})
const filter = ref({
  status: 'all',
  page: {number: 1},
  reports: true
})
const loading = ref(false)
onMounted(async()=>{
  loading.value = true
  let response = await retrieve_children()
  // console.log("🚀 ~ onMounted ~ response:", response)
  await getReportStatus()
  await getPackages()
  // console.log("🚀 ~ file: application.vue:12 ~ onMounted ~ response:", response)
  loading.value = false
  if (response.error){
    swalError(response.result.error)
  }else{
    if (!response.result.data.status.empty){
      children.value = parseReportToChild(response.result.data.children.data, response.result.data.children.included)
      // children.value = response.result.data.children.data
      pagination.value = response.result.data.pagination
    }
  }
})

function parseReportToChild(children, reports){
  children = children.map((child)=>{
    let tempReports = []
    child.relationships.reports.data.forEach((report)=>{
      let tempReport = reports.find(item => item.id == report.id)
      tempReports.push(tempReport)
      tempReport = null
    })
    child.reports = tempReports.sort((a,b) =>  parseInt(a.id) - parseInt(b.id))
    tempReports = []
    return child
  })
  // console.log("🚀 ~ parseReportToChild ~ children:", children)
  return children
}

async function getReportStatus(){
  let response = await get_terms('report_status')
  let tempStatus = response.result.data.data.map((item)=>{
    return {
      name: item.attributes.name,
      id: item.id,
      active: false
    }
  })
  applicationOption.value = [...applicationOption.value, ...tempStatus]
}

const packages = ref([])
async function getPackages(){
  let response = await get_packages()
  packages.value = response.result
}

function get_package_name(report){
  let name = ''
  name = packages.value.find(item => item.id == report.attributes.report_type)?.options.name.value
  return name
}

function get_report_status_name(report_status_id){
  if(!report_status_id){
    return '-'
  }
  let statusObj = applicationOption.value.find(status => status.id == report_status_id)
  return statusObj.name
}
// need to set option list in database
const applicationOption = ref([
  {
    name: "All",
    id: "all",
    active: true
  }
])

async function filterChild(key, val){
  if (key == 'status'){
    if (!val.active) {
      applicationOption.value.forEach(a => {
        a.active = false;
      })
      val.active = !val.active
    }
    filter.value.status = val.id
  }else{ // page
    filter.value.page.number = pagination.value[val]
  }
  loading.value = true
  let response = await filterChildren(filter.value)
  loading.value = false
  if (!response.error){
    if (!response.result.data.status.empty){
      children.value = parseReportToChild(response.result.data.children.data, response.result.data.children.included)
      // children.value = response.result.data.children.data
      pagination.value = response.result.data.pagination
    }else{
      children.value = []
    }
  }else{
    Swal.fire({
      title: 'Error',
      text: 'Error retrieving children',
      icon: 'error'
    })
  }
}

const currentChild = ref({})

// function showInfo(child){
//   if (currentChild.value.id == child.id){
//     currentChild.value = {}
//   }else{
//     currentChild.value = child
//   }
// }

async function deletePopup(child){
  Swal.fire({
    title: 'Delete?',
    text: `Confirm delete ${child.attributes.name}?`,
    icon: 'error',
    confirmButtonText: 'Delete',
    denyButtonText: `Cancel`,
    showDenyButton: true,
    reverseButtons: true,
  }).then((result) => {
    if (result.isConfirmed) {
      deleteChild(child)
    }
  })
}

async function deleteChild (child){
  let response = await delete_child(child.id)
  if (response.error){
    Swal.fire({
      title: 'Error',
      html: response.result.error,
      icon: 'error'
    })
    return
  }
  Swal.fire({
    title: 'Deleted',
    text: 'Child has been deleted',
    icon: 'success'
  })
  let childInd = children.value.findIndex(item => item.id == child.id)
  children.value.splice(childInd, 1)
}
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Application List & Status"/>
    
    <!-- Filter Section -->
    <div class="d-flex mb-2 overflow-x-auto">
      <button v-for="item in applicationOption"
        class="me-2 btn btn-light-primary shadow px-4 py-2 rounded-pill"
        :class="{'active': item.active}"
        @click="filterChild('status', item)"
      >
        {{item.name}}
      </button>
    </div>

    <!-- Content Section -->
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body row">
            <loadingCard v-if="loading" loadingType="list"/>
            <template v-else>
              <template v-if="children.length != 0">
                <div 
                  v-for="child in children" :key="child.attributes.id"
                  class="col-md-4 child-card p-1" 
                >
                  <div class="card shadow-none border mb-2"
                    :class="child.status"
                  >
                    <div v-auto-animate class="card-body p-3">
                      <div class="row">
                        <div class="col-8">
                          <router-link class="my-auto text-dark fw-medium mb-0"
                            :to="{
                              name: 'dna-report-single-application', 
                              params: {id: child.attributes.id }, 
                              query: {report_only: true}
                            }"
                          >
                            <span class="text-capitalize fw-semibold tracking-wider">
                              {{ child.attributes.name }}
                            </span>
                          </router-link >
                        </div>

                        <!-- Action Button -->
                        <div class="col-4">
                          <div class="flex-center">
                            <button @click="deletePopup(child)" class="btn icon-btn btn-light-danger m-1">
                              <vue-feather type="trash" size="1rem"/>
                            </button>

                            <router-link class="btn icon-btn btn-light-primary m-1"
                              :to="{
                                name: 'dna-report-single-application',
                                params: {id: child.attributes.id }, 
                                query: {report_only: true}
                              }"
                            >
                              <vue-feather type="chevron-right"/>
                            </router-link>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <p class="my-auto fw-medium mb-0">
                            <span class="text-secondary text-capitalize">age: </span>
                            <span class="fw-semibold tracking-wider">{{ child.attributes ? getAge(child.attributes.date_of_birth) : 'Error' }}</span>
                          </p>
                          <p class="my-auto fw-medium mb-0">
                            <span class="text-secondary text-capitalize">gender: </span>
                            <span class="text-capitalize fw-semibold tracking-wider">{{ child.attributes.gender }}</span>
                          </p>
                        </div>
                      </div>
                      
                      <div class="row mt-3">
                        <template v-for="report in child.reports" :key="report.id">
                          <p v-if="get_report_status_name(report.attributes.status) !== '-'" class="mb-0">
                            {{ get_package_name(report) }} :  
                            <span class="fw-semibold">{{ get_report_status_name(report.attributes.status) || '-' }}</span>
                          </p>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- pagination -->
                <div class="col-12 m-t-20">
                  <nav aria-label="...">
                    <ul class="pagination pagination-primary justify-content-end">
                      <li class="page-item"
                        v-if="'first' in pagination"
                      >
                        <a class="page-link" href="javascript:void(0)" tabindex="-1"
                          @click="filterChild('page', 'first')"
                        >
                          First
                        </a>
                      </li>
                      <li class="page-item"
                        :class="'prev' in pagination ? '' : 'disabled'"
                      >
                        <a class="page-link" href="javascript:void(0)" tabindex="-1"
                          @click="filterChild('page', 'prev')"
                        >Previous</a>
                      </li>
                      <!-- <li class="page-item">
                        <a class="page-link" href="javascript:void(0)">1</a>
                      </li> -->
                      <li class="page-item active">
                        <a class="page-link" href="javascript:void(0)"
                          @click="filterChild('page', 'current')"
                        >
                          {{ pagination.current }}
                          <span class="sr-only">(current)</span>
                        </a>
                      </li>
                      <!-- <li class="page-item">
                        <a class="page-link" href="javascript:void(0)">3</a>
                      </li> -->
                      <li class="page-item"
                        :class="'next' in pagination ? '' : 'disabled'"
                      >
                        <a class="page-link" 
                          href="javascript:void(0)"
                          @click="filterChild('page', 'next')"
                        >Next</a>
                      </li>
                      <li class="page-item"
                        v-if="'last' in pagination"
                      >
                        <a class="page-link" 
                          href="javascript:void(0)"
                          @click="filterChild('page', 'last')"
                        >Last</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </template>

              <template v-else>
                <EmptyCard />
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>